import * as actions from './storyActions'

const contentInit = {
	title: {},
	image: {},
	content: []
}
export default (state = contentInit, action) => {
	switch (action.type) {
		case actions.GET_STORY_SUCCESS:
			return {
				...state,
        id: action.id,
				title: action.title,
				image: action.image,
				content: action.content
			}
		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/pages/story/storyReducer.js